import { Modal, notification } from "antd";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { VolunteersStore } from "./VolunteersStore";
import FileSaver from "file-saver";
import { ApolloError } from "apollo-boost";
import { dataURItoBlob } from "../../common/Utils";

export class VolunteerStore {
  id: string = "";
  volunteersStore: VolunteersStore;
  volunteer?: any;
  loading = false;
  emailSending = false;

  exporting = false;

  applications = {
    loading: false,
    items: [],
  };

  constructor(volunteersStore: VolunteersStore) {
    makeAutoObservable(this, {
      volunteersStore: false,
    });
    this.volunteersStore = volunteersStore;
  }

  @action refresh(loading = true) {
    this.loading = loading;
    Api.volunteer
      .volunteer(this.id)
      .then((res) => {
        runInAction(() => {
          this.volunteer = res.data.volunteer;
        });
      })
      .finally(() => (this.loading = false));
  }

  @action refreshApplications() {
    this.applications.loading = true;
    Api.volunteer
      .applications(this.id)
      .then((res) => {
        runInAction(() => {
          this.applications.items = res.data.volunteerApplications;
        });
      })
      .finally(() => (this.applications.loading = false));
  }

  @action sendHostEmail() {
    this.emailSending = true;
    Api.volunteer
      .sendHostEmail(this.id)
      .then((res) => {
        runInAction(() => {
          notification.success({
            message: "Email sent successfully",
          });
        });
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.emailSending = false));
  }

  @action confirmApplication(id, confirmed) {
    Api.volunteer
      .confirmApplication(id, confirmed)
      .then((res) => {
        notification.success({ message: `${confirmed ? "Confirm" : "Reject"} Successfully` });
        setTimeout(() => this.refreshApplications(), 3000);
      })
      .catch((err: ApolloError) => {});
  }

  @action setStatus(paused: boolean) {
    Modal.confirm({
      content: "Are you sure?",
      onOk: () => {
        return Api.volunteer.setVolunteerStatus(this.id, paused).then(() => {
          setTimeout(() => {
            this.volunteersStore.refresh(false);
            this.refresh(false);
          }, 3000);
        });
      },
    });
  }

  @action
  active(id: string) {
    if (this.id === id) return;
    this.id = id;
    this.volunteer = null;
    this.applications.items = [];
    console.log("active fund id", id);
    this.refresh();
    this.refreshApplications();
  }

  @action onExport() {
    this.exporting = true;
    Api.volunteer
      .exportVolunteer(this.id)
      .then((res) => {
        runInAction(() => {
          const { filename, data } = res.data.exportVolunteer;
          let blob = dataURItoBlob(data, filename);
          FileSaver.saveAs(blob, filename);
        });
      })
      .finally(() => (this.exporting = false));
  }
}
